import React from 'react';
import { Card, Tag, Typography } from 'antd';
import { Link } from 'react-router-dom';
import './PostCard.css';

const { Title, Text, Paragraph } = Typography;

const PostCard = ({ post }) => {
  const { id, title, excerpt, date, tags, author, readTime } = post;

  return (
    <Card 
      hoverable 
      className="post-card"
    >
      <div className="post-content" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Title 
          level={4} 
          className="post-title"
        >
          <Link to={`/post/${id}`}>{title}</Link>
        </Title>
        
        <Paragraph 
          ellipsis={{ rows: 3, expandable: false }}
          className="post-excerpt"
        >
          {excerpt}
        </Paragraph>
        
        <div className="post-meta" style={{ marginTop: 'auto', paddingTop: '12px', borderTop: '1px solid #f0f0f0' }}>
          <div className="post-tags">
            {tags && tags.map((tag, index) => (
              <Tag key={index} color="blue">{tag}</Tag>
            ))}
          </div>
          <div className="post-info">
            <Text type="secondary">{author} • {date}</Text>
            {readTime && <Text type="secondary"> • {readTime}</Text>}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default PostCard;